import SettingsMyCompany from './MyCompany';
import { createMyCompanySettingsHandle } from './handle';

export default {
  Component: SettingsMyCompany,
  createHandle: createMyCompanySettingsHandle
};
